import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cx } from './cx';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  mono?: boolean;
};

/**
 * Same `.mf-input` class as Input — the styles size correctly via line-height,
 * the only difference is the underlying element supports multi-line content.
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { mono, className, ...props },
  ref,
) {
  return <textarea ref={ref} className={cx('mf-input', mono && 'mono', className)} {...props} />;
});
